/**
 * AG Grid v35+ requires explicit module registration before any grid renders.
 * This file must be imported exactly once, at the top of the app entry point.
 *
 * See: https://www.ag-grid.com/react-data-grid/modules/
 */
import { ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule } from 'ag-grid-enterprise';
import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';
import { AgGridLicenseService } from 'src/services/aws/AgGridLicenseService';

ModuleRegistry.registerModules([AllEnterpriseModule.with(AgChartsEnterpriseModule)]);
AgGridLicenseService.applyCachedLicense();
